import React from 'react';
import PropTypes from 'prop-types';
import Link from '@nubank/nuds-web/components/Link/Link';
import Box from '@nubank/nuds-web/components/Box/Box';
import styled from 'styled-components';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const StyledBox = styled(Box)`
  cursor: pointer;
  gap: 32px;
`;

function AppStoreButtons({
  appStoreUrl = 'https://link.nubank.com.br/5YMt1FwBMBb',
  googlePlayUrl = 'https://link.nubank.com.br/CkI2cIfCMBb',
}) {
  return (
    <StyledBox
      display="flex"
      justifyContent="center"
      flexDirection="row"
    >
      {/* App Store Button */}
      <Link
        href={appStoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        variant="basic"
      >
        <Image src="one-step/apple-store.svg" alt="Apple Store" width="20" height="20" />
      </Link>

      {/* Google Play Button */}
      <Link
        href={googlePlayUrl}
        target="_blank"
        rel="noopener noreferrer"
        variant="basic"
      >
        <Image src="one-step/google-store.svg" alt="Google Play" width="20" height="20" />
      </Link>
    </StyledBox>
  );
}

AppStoreButtons.propTypes = {
  appStoreUrl: PropTypes.string,
  googlePlayUrl: PropTypes.string,
};

AppStoreButtons.defaultProps = {
  appStoreUrl: 'https://link.nubank.com.br/5YMt1FwBMBb',
  googlePlayUrl: 'https://link.nubank.com.br/CkI2cIfCMBb',
};

export default AppStoreButtons;
